import { render, staticRenderFns } from "./GuideTourRecorder.vue?vue&type=template&id=1f4728fc"
import script from "./GuideTourRecorder.vue?vue&type=script&lang=js"
export * from "./GuideTourRecorder.vue?vue&type=script&lang=js"
import style0 from "./GuideTourRecorder.vue?vue&type=style&index=0&id=1f4728fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports